<template>
  <div class="container">
    <el-form
      ref="ruleForm"
      :model="formData"
      :rules="rules"
      :label-position="labelPosition"
      label-width="80px"
      :inline="true"
    >
      <div class="category"><span>收货地址</span></div>
      <el-form-item label="收件人">
        <el-input
          v-model="formData.consigneeName"
          readonly
          placeholder="收件人"
        />
      </el-form-item>
      <el-form-item label="联系方式">
        <el-input
          v-model="formData.consigneeMobile"
          readonly
          placeholder="联系方式"
        />
      </el-form-item>
      <el-form-item label="收货地址" style="width: 100%">
        <el-input
          :value="consigneeFullAddress"
          readonly
          type="textarea"
          placeholder="收货地址"
          style="width: 300px"
        />
      </el-form-item>
      <div class="category"><span>发货信息</span></div>
      <el-form-item label="快递公司" prop="shippingCompany">
        <el-select
          v-model="formData.shippingCompany"
          placeholder="请选择快递公司"
        >
          <el-option
            v-for="item in COURIER_COMPANY"
            :key="item.value"
            :label="item.value"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="物流单号" prop="shippingNo">
        <el-input v-model="formData.shippingNo" placeholder="物流单号" />
      </el-form-item>
      <el-form-item label="备注" style="width: 100%">
        <el-input
          v-model="formData.shippingRemark"
          type="textarea"
          placeholder="备注"
          style="width: 300px"
        />
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <template v-if="isEdit">
        <el-button type="primary" @click="submitData('ruleForm')"
          >提交</el-button
        >
        <el-button @click="resetField('ruleForm')">取消</el-button>
      </template>
    </div>
  </div>
</template>
<script>
import {
  pharmacistOrderShipping,
  pharmacistOrderShippingForm,
} from "@/api/doctor.js";
import { COURIER_COMPANY } from "@/utils/eum";
export default {
  name: "DrugSendDrug",
  props: {
    isEdit: { type: Number, default: 0 },
    itemList: {
      type: Object,
      default: () => [],
    },
  },
  data() {
    return {
      COURIER_COMPANY,
      dialogFormVisible: true,
      labelPosition: "left",
      formData: {},
      rules: {
        shippingCompany: [
          { required: true, message: "请选择快递公司", trigger: "change" },
        ],
        shippingNo: [
          { required: true, message: "请填写物流单号", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    consigneeFullAddress() {
      const {
        consigneeAddress,
        consigneeProvince,
        consigneeCity,
        consigneeDistrict,
      } = this.formData;
      return [
        consigneeProvince,
        consigneeCity,
        consigneeDistrict,
        consigneeAddress,
      ]
        .filter((city) => !!city)
        .join(" ");
    },
  },
  created() {
    this.formData = this.itemList;
    this.getFormList();
  },
  methods: {
    async getFormList() {
      const res = await pharmacistOrderShippingForm({ id: this.itemList.id });
      this.formData = res.data || {};
    },
    async submitData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.audit();
        } else {
          return false;
        }
      });
    },
    async audit() {
      const res = await pharmacistOrderShipping(this.formData);
      if (res.code === 1) {
        this.$message({
          message: "设置成功",
          type: "success",
        });
        this.$emit("refresh");
      }
    },
    resetField(formName) {
      this.$refs[formName].resetFields();
      this.$emit("closeForm");
    },
  },
};
</script>
<style lang="scss" scoped>
.el-form-item--small.el-form-item {
  float: left !important;
  margin-right: 30px !important;
  margin-right: 10px !important;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 185px !important;
}
.el-dialog {
  margin-top: 8vh;
  width: 80%;
}
.category {
  float: left;
  width: 100%;
  height: 30px;
  border-bottom: 1px solid #dcdfe6;
  margin: 0 15px 20px 0;
  font-weight: 600;
  font-size: 16px;
}
.dialog-footer {
  clear: both;
}
</style>
